module.exports = __webpack_public_path__ + "img/ic-search.2cd7b9c5.svg";